"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEBSOCKET_CONTEXT = exports.MAX_PAGES_PER_MODULE = exports.MAX_MODULES = exports.EndpointErrors = exports.ContentImportEndpointKeys = void 0;
var ContentImportEndpointKeys;
(function (ContentImportEndpointKeys) {
    ContentImportEndpointKeys["GetProducts"] = "contentImport.getProducts";
    ContentImportEndpointKeys["GetProductImage"] = "contentImport.getProductImage";
    ContentImportEndpointKeys["GetModules"] = "contentImport.getModules";
    ContentImportEndpointKeys["GetPages"] = "contentImport.module.getPages";
    ContentImportEndpointKeys["ImportModules"] = "contentImport.importModules";
})(ContentImportEndpointKeys || (exports.ContentImportEndpointKeys = ContentImportEndpointKeys = {}));
var EndpointErrors;
(function (EndpointErrors) {
    EndpointErrors["ImportInProgress"] = "0053";
})(EndpointErrors || (exports.EndpointErrors = EndpointErrors = {}));
exports.MAX_MODULES = 50;
exports.MAX_PAGES_PER_MODULE = 200;
exports.WEBSOCKET_CONTEXT = 'ContentImport';
